import theme from '../../../lib/theme';

const { corners, shadows, colors, layouts } = theme;

export default () => ({
  link: {
    textDecoration: 'none',

    '&:hover .Story__title': {
      textDecoration: 'underline',
      color: colors.sas.primary,
    },

    '&:hover .Story__image': {
      boxShadow: shadows.lowest,
    },
  },

  container: {
    ...layouts.spacedColumn('s'),
  },

  textContainer: {
    ...layouts.spacedColumn('xxs'),
  },

  textInnerContainer: {
    ...layouts.spacedColumn('s'),
  },

  titleContainer: {
    ...layouts.spacedColumn('xxs'),
  },

  heavyImage: {
    backgroundColor: colors.grey,
    width: '100%',
    borderRadius: corners.m,
    border: `1px solid ${colors.grey}`,
    transition: 'all 150ms linear',
  },

  title: {
    transition: 'all 150ms linear',
  },
});
